var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-page"},[_c('div',{staticClass:"inner-page",class:{'app-center': _vm.centered}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }